// src/hooks/dashboard/useCategoriesTree.ts

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { categoriesTreeQueryOptions } from "@/services/queries/dashboards/categoriesQueries";
import type { CategoryTreeNode } from "@/types/dashboards/categories";

export interface CategoriesMaps {
  codeToName: Record<string, string>;
  codeToId: Record<string, number>;
  parentByCode: Record<string, string | null>;
}

export function useCategoriesTree() {
  const query = useQuery(categoriesTreeQueryOptions());

  const maps = useMemo<CategoriesMaps>(() => {
    const codeToName: Record<string, string> = {};
    const codeToId: Record<string, number> = {};
    const parentByCode: Record<string, string | null> = {};

    const walk = (node: CategoryTreeNode, parentCode: string | null) => {
      codeToName[node.category_code] = node.category_name;
      codeToId[node.category_code] = node.category_id;
      parentByCode[node.category_code] = parentCode;
      node.children?.forEach((child) => walk(child, node.category_code));
    };

    query.data?.roots?.forEach((r) => walk(r, null));

    return { codeToName, codeToId, parentByCode };
  }, [query.data]);

  return {
    ...query,
    roots: query.data?.roots ?? [],
    maps,
  };
}


